import _regeneratorRuntime from 'babel-runtime/regenerator';
var _this = this;
function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }
        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }
      return step("next");
    });
  };
}
import { change } from 'redux-form';
import { callAPI } from './apiActions';
import { showSnack } from './snackbarActions';
import { closeSidePane } from './sidePaneActions';
export var FETCHING_ACCOUNT_WITHDRAW_INFOS = 'FETCHING_ACCOUNT_WITHDRAW_INFOS';
export var RECEIVE_ACCOUNT_WITHDRAW_INFOS = 'RECEIVE_ACCOUNT_WITHDRAW_INFOS';
export var ACCOUNT_WITHDRAW_INFOS_ERROR = 'ACCOUNT_WITHDRAW_INFOS_ERROR';
export var SELECT_WITHDRAW_BANK = 'SELECT_WITHDRAW_BANK';
export var DELETE_WHITELISTED_ADDRESS = 'DELETE_WHITELISTED_ADDRESS';
export var fetchingAccountWithdrawInfos = {
  type: FETCHING_ACCOUNT_WITHDRAW_INFOS
};
export var receiveAccountWithdrawInfos = function receiveAccountWithdrawInfos(payload) {
  return {
    type: RECEIVE_ACCOUNT_WITHDRAW_INFOS,
    payload: payload
  };
};
export var accountWithdrawInfosError = function accountWithdrawInfosError(payload) {
  return {
    type: ACCOUNT_WITHDRAW_INFOS_ERROR,
    payload: payload
  };
};
export var selectWithdrawBank = function selectWithdrawBank(payload) {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var withdrawInfos, bank;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              withdrawInfos = getState().eotcWithdraw.withdrawInfos;
              bank = withdrawInfos.find(function (i) {
                return i.AccountWithdrawInfoId === payload;
              });
              if (bank) {
                dispatch(change('createFiatWithdraw', 'Name', bank['Name']));
                dispatch(change('createFiatWithdraw', 'AccountIdentifier', bank['AccountIdentifier']));
                dispatch(change('createFiatWithdraw', 'AccountWithdrawInfoId', bank['AccountWithdrawInfoId']));
                dispatch(change('createFiatWithdraw', 'BankAccountNumber', bank['Name'] + ' - *' + bank['AccountIdentifier']));
              } else if (payload === 'default') {
                dispatch(change('createFiatWithdraw', 'Name', ''));
                dispatch(change('createFiatWithdraw', 'AccountIdentifier', ''));
                dispatch(change('createFiatWithdraw', 'AccountWithdrawInfoId', ''));
                dispatch(change('createFiatWithdraw', 'BankAccountNumber', ''));
              }
            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
export var fetchAccountWithdrawInfos = function fetchAccountWithdrawInfos() {
  return function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch, getState) {
      var payload, data;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              dispatch(fetchingAccountWithdrawInfos);
              payload = {
                AccountId: getState().user.selectedAccountId,
                OMSId: getState().user.userInfo.OMSId
              };
              _context2.next = 4;
              return dispatch(callAPI('GetAccountWithdrawInfos', payload));
            case 4:
              data = _context2.sent;
              if (!(data && !data.hasOwnProperty('errormsg'))) {
                _context2.next = 7;
                break;
              }
              return _context2.abrupt('return', dispatch(receiveAccountWithdrawInfos(data)));
            case 7:
              return _context2.abrupt('return', dispatch(accountWithdrawInfosError(data.errormsg)));
            case 8:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));
    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();
};
export var DeleteAccountWithdrawInfo = function DeleteAccountWithdrawInfo(AccountWithdrawInfoId) {
  return function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(dispatch, getState) {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return dispatch(callAPI('DeleteAccountWithdrawInfo', {
                AccountWithdrawInfoId: AccountWithdrawInfoId
              })).then(function (res) {
                if (res.result) {
                  dispatch(showSnack({
                    id: 'whitelistDeleteSuccess',
                    text: 'Successfully removed address.',
                    type: 'success'
                  }));
                  dispatch({
                    type: DELETE_WHITELISTED_ADDRESS,
                    payload: AccountWithdrawInfoId
                  });
                  return;
                }
                dispatch(showSnack({
                  id: 'whiteListDeleteError',
                  text: 'Error deleting address.',
                  type: 'warning'
                }));
              });
            case 2:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this);
    }));
    return function (_x5, _x6) {
      return _ref3.apply(this, arguments);
    };
  }();
};
export var CreateAccountWithdrawInfo = function CreateAccountWithdrawInfo(payload) {
  return function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(dispatch, getState) {
      var state, data;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              state = getState();
              _context4.next = 3;
              return dispatch(callAPI('CreateAccountWithdrawInfo', Object.assign({}, payload, {
                OMSId: state.user.userInfo.OMSId,
                AccountId: state.user.selectedAccountId
              })));
            case 3:
              data = _context4.sent;
              if (!data.result) {
                _context4.next = 8;
                break;
              }
              dispatch(showSnack({
                id: 'whitelistAddressSuccess',
                text: 'Successfully whitelisted. Please check your email to confirm.',
                type: 'success'
              }));
              dispatch(closeSidePane());
              return _context4.abrupt('return');
            case 8:
              dispatch(showSnack({
                id: 'whitelistAddressError',
                text: '' + data.errormsg + (data.detail && ': ' + data.detail),
                type: 'warning'
              }));
            case 9:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this);
    }));
    return function (_x7, _x8) {
      return _ref4.apply(this, arguments);
    };
  }();
};